import { useMemo } from "react";
import { useIntl } from "react-intl";

import { CollapsibleCard } from "@/components/CollapsibleCard/CollapsibleCard";
import { HotelFacilityList } from "@/features/hotels/components/hotel/HotelFacilityList";
import type { HotelData } from "@/features/hotels/types/types";
import {
  buildHotelFacilitiesDisplayModel,
  type HotelFacilitiesDisplayModel,
} from "@/features/hotels/utils/facilities/buildHotelFacilitiesDisplayModel";

type Props = {
  hotel: HotelData;
  facilitiesModel?: HotelFacilitiesDisplayModel;
};

export const HotelFacilitiesCard = ({ hotel, facilitiesModel }: Props) => {
  const intl = useIntl();

  const { groups } = useMemo(
    () =>
      facilitiesModel ??
      buildHotelFacilitiesDisplayModel(hotel.descriptions?.facilities),
    [hotel.descriptions?.facilities, facilitiesModel],
  );

  if (groups.length === 0) {
    return null;
  }

  return (
    <CollapsibleCard
      title={intl.formatMessage({
        defaultMessage: "Hotel Facilities",
        description: "Section heading for full hotel facilities list",
      })}
    >
      <HotelFacilityList facilityGroups={groups} />
    </CollapsibleCard>
  );
};
